var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSlideIzq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M18 1c9.388 0 17 7.612 17 17s-7.612 17-17 17S1 27.388 1 18 8.612 1 18 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.25 18.5l6.375-6.375L20.462 10 12 18.5l8.462 8.5 2.163-2.125L16.25 18.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSlideIzq);
export default __webpack_public_path__ + "static/media/arrow-slide-izq.c1f6550add5bcff1c0b391d74b1377f0.svg";
export { ForwardRef as ReactComponent };